import React from "react";
import asknowSignet from "../../../assets/icons/asknow-signet.svg";

import defaultStyle from "./Footer.module.scss";

const Footer: React.FC = () => {
  return (
    <div className={defaultStyle.container}>
      <img src={asknowSignet} alt="Asknow" className={defaultStyle.signet} />
      <p className={defaultStyle.text}>
        ASKnow is a part of Acoucou Platform &copy; {new Date().getFullYear()}. Provided under Creative Commons license
        [
        <a rel={"noreferrer"} href="https://creativecommons.org/licenses/by-nc-nd/4.0/" target="_blank">
          CC BY-NC-ND 4.0
        </a>
        ]
      </p>
    </div>
  );
};

export default Footer;
